import { AppConfigService } from './../common/services/app-config.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { HttpRequestService } from '../common/services/http-request.service';
import { Utils } from '../common/services/utils.service';
import { AuthService } from '../auth/auth.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DialogService } from 'primeng/dynamicdialog';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [DialogService]
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  pwdDetails: Object;

  constructor(private authService: AuthService,
    private httpService: HttpRequestService,
    private fb: FormBuilder,
    private utils: Utils,
    private router: Router,
    private dialogService: DialogService) { }

  onSubmit(form) {
    form.methodName = 'fetchTenantId';
    form.answer = '';
    const requestData = {
      'workFlowName': 'CoreLoginService',
      'processType': 'Screen',
      'workFlowParams': JSON.stringify(form)
    };

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
      .subscribe((response) => {
        this.authService.setUserDetails({ ...form, ...response['hdrcache'][0] });
        if (this.authService.isLoggedIn) {
          const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/app';
          this.router.navigate([redirect]);
          // this.authService.inactivityTime();
          this.authService.dashboardItems = response.consoleTransaction_array;
        } else {
          this.router.navigate(['/login']);
        }
      },
        (error) => {
          this.utils.showNotification("Unable to Reach the server", 'error', 'Failure');
        }
      );
  }

  onResetPassword() {
    const scope = this;
    const ref = scope.dialogService.open(ForgotPasswordComponent, {
      data: { "pwdDetails": scope.pwdDetails },
      header: ('Forgot Password?'),
      width: '30%',
      contentStyle: { "max-height": "500px", "overflow": "auto" }
    });

    ref.onClose.subscribe(() => {
    });
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      strUserId: ['', Validators.required],
      strPassword: ['', Validators.required]
    });

    document.getElementById('load-container').remove();
    document.getElementById('first-loader').remove();
    document.getElementById('first-loader-footer').remove();
  }

}
